import { render, staticRenderFns } from "./CheckAllRecieversPackage.vue?vue&type=template&id=826caeac&scoped=true"
import script from "./CheckAllRecieversPackage.vue?vue&type=script&lang=js"
export * from "./CheckAllRecieversPackage.vue?vue&type=script&lang=js"
import style0 from "./CheckAllRecieversPackage.vue?vue&type=style&index=0&id=826caeac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826caeac",
  null
  
)

export default component.exports